
import TableList from "@components/templates/tablelist";
import { HttpAmazonAccountList } from '@/service/boss/allot';
import { mapState,mapGetters } from "vuex";
export default {
    mixins: [TableList],
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 120,
            },
            Plugins: {show: true},
            erpSkusList:[],
            category:'',
            exportdata: {},
        }
    },
    methods: {
        ajaxRequest: HttpAmazonAccountList,
        interceptRequest(params){
            params.lineId = params.search.EQ_lineId
            params.flag = params.search.EQ_accountFlag
            params.sellerSku = params.search.EQ_sellerSku
            params.erpSku = params.search.EQ_erpSku
            params.updatedAt = params.search.EQ_updatedAt ? params.search.EQ_updatedAt+' 00:00:00' : null 

            delete params.search.EQ_lineId
            delete params.search.EQ_accountFlag
            delete params.search.EQ_sellerSku
            delete params.search.EQ_erpSku
            delete params.search.EQ_updatedAt
            this.exportdata = params
            return params
        },
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'exportQuery':
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/StockAccountAssign/amazon/export", this.exportdata, 'download').catch(err => {
                        // this.$VMessage.error(err.message);
                    })
                break
                
            }
        },
    },
    computed: {
        ...mapGetters('diction',['getNewDifferentAllProductList','getNewAccountList']),
        // 搜索下拉框展示内容
        SearchsData() {
            return  [
                {
                    label: this.$t('global.common.project',{defaultValue:'项目'}),
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options: this.getNewDifferentAllProductList,
                    props:{
                        filterable:true,
                    },
                    show:true,
                },

                {
                    label: this.$t('global.common.channel',{defaultValue:'店铺'}),
                    tag: 'vSelect',
                    key: 'EQ_accountFlag',
                    show:true,
                    options: this.getNewAccountList,
                    props:{
                        filterable:true,
                    }
                },

                {
                    label: "SellerSKU",
                    tag: 'vInput',
                    key: 'EQ_sellerSku',
                    show:true,
                },
                {
                    label: "ERPSKU",
                    tag: 'vInput',
                    key: 'EQ_erpSku',
                    show:true,
                },
                {
                    label: this.$t('fbb.alloment.date',{defaultValue:'日期'}),
                    tag: 'vDatepicker',
                    key: 'EQ_updatedAt',
                    props:{
                        format:'yyyy-mm-dd',
                        confirm:false,
                    },
                    show:true,
                },
            ]
        },
        ToolsData(){
            return [
                {
                    name: "查询条件导出",
                    theme: 'info',
                    operate: 'exportQuery',
                },
            ]
        },
        // table的展示数据
        columns() {
            let that = this
            return  [
            {
                title: this.$t('global.common.project',{defaultValue:'项目'}),
                render: (h, { row }) => this.findRenderLabel(this.getNewDifferentAllProductList, row.lineId)
            },
            {
                title: this.$t('global.common.channel',{defaultValue:'店铺'}),
                key:'accountId',
                render: (h, { row }) => {
                    let accountItem = that.getNewAccountList.filter(item => {
                        return item.value === row.accountId
                    })[0].label
                    return <div>{accountItem}</div>
                }
            },
            {
                title: 'SellerSKU',
                key:'sellerSku',
                sortable: true
            },
            {
                title: 'ERPSKU',
                key:'erpSku',
                sortable: true
            },
            {
                title: this.$t('erp.virtualstore.pushnumber',{defaultValue:'推送数量'}),
                key: 'stockPush',
                sortable: true
            },
            {
                title: 'Amazon'+this.$t('fbb.accountmanage.template_name',{defaultValue:'模板名称'}),
                key: 'amazonTemplateId',
                sortable: true
            },
            {
                title: this.$t('erp.virtualstore.computationtime',{defaultValue:'计算时间'}),
                key: 'updatedAt',
                sortable: true
            },
        ];
        },
        
    },

};
